import React from 'react';
import styles from '../../index.module.sass';

const PolicesAndProceduresING = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div className={styles.Titles}>
          <div className={styles.title}>Politicas </div>
          <div className={styles.subtitle}>y Procedimientos</div>
        </div>
        <p className={styles.paragraphTitle}>Código de Ética</p>
        <p>
          Como Consultor Independiente de Terramar Brands LLC (en adelante “TERRAMAR” o “la
          Compañía”), por la presente prometo y acepto que:
        </p>
        <ol>
          <li className={styles.list}>
            Seré honesto y transparente &nbsp;
            <span className={styles.span}>
              en todas mis transacciones mientras actúe como Consultor Independiente de TERRAMAR, y
              realizaré todas mis actividades de una manera que mejore mi reputación y la reputación
              de TERRAMAR.
            </span>
          </li>
          <li className={styles.list}>No participaré en ninguna práctica ilegal o engañosa.</li>

          <li className={styles.list}>
            Respetaré el tiempo y la privacidad &nbsp;
            <span className={styles.span}>
              de todas las personas a quienes contacte para convertirse en clientes minoristas o
              Consultores Independientes de TERRAMAR. Seré cortés y respetuoso con todas las
              personas con las que tenga contacto en el curso de mi negocio TERRAMAR. Reconozco que
              los directivos de TERRAMAR mantienen firmes convicciones personales en cuanto a la
              conducta ética que debe observar todo Consultor Independiente de TERRAMAR.
            </span>
          </li>
          <li className={styles.list}>
            Cumpliré mis responsabilidades de liderazgo como Patrocinador, &nbsp;
            <span className={styles.span}>
              lo que incluye capacitar y brindar apoyo a los Consultores Independientes dentro de mi
              organización. Proporcionaré apoyo continuo a mi organización, reconociendo que las
              personas a quienes patrocino tendrán una mayor oportunidad de éxito en TERRAMAR cuando
              reciban formación y apoyo continuos.
            </span>
          </li>
          <li className={styles.list}>
            No realizaré afirmaciones o representaciones sobre ingresos &nbsp;
            <span className={styles.span}>
              relacionadas con el plan de compensación de TERRAMAR, excepto aquellas contenidas en
              la literatura oficial de TERRAMAR. Reconozco que el éxito de un Consultor
              Independiente de TERRAMAR depende de múltiples factores, tales como el tiempo y
              esfuerzo dedicados a su negocio, así como su capacidad organizacional.
            </span>
          </li>
          <li className={styles.list}>
            No haré declaraciones sobre los productos, servicios o la oportunidad de ingresos de
            TERRAMAR, &nbsp;
            <span className={styles.span}>
              salvo las publicadas en la literatura oficial de TERRAMAR. Recordaré que incluso mi
              experiencia personal respecto de los beneficios obtenidos de los productos, servicios
              u oportunidad de ingresos de TERRAMAR puede interpretarse como una afirmación de
              TERRAMAR si utilizo esas experiencias como herramienta de venta.
            </span>
          </li>
          <li className={styles.list}>
            Honraré siempre la garantía de satisfacción total del 100 % o reembolso de dinero de
            TERRAMAR
            <span className={styles.span}>al tratar con mis clientes minoristas.</span>
          </li>
          <li className={styles.list}>
            Entiendo y acepto que soy el único responsable de todas las obligaciones financieras y
            legales
            <span className={styles.span}>
              que incurra en el curso de mi negocio como Consultor Independiente de los productos y
              servicios de TERRAMAR, incluyendo impuestos sobre el trabajo independiente, impuestos
              sobre la renta, impuestos sobre ventas, tarifas de licencias, etc. Entiendo que soy un
              contratista independiente para todos los propósitos fiscales federales y estatales.
            </span>
          </li>
          <li className={styles.list}>
            Competiré de manera agresiva pero justa, &nbsp;
            <span className={styles.span}>
              y respetaré a los participantes de otras oportunidades de mercadeo en red. No
              solicitaré listas de Consultores Independientes ni listas de clientes de otras
              compañías de mercadeo en red, ni concentraré mis esfuerzos de ventas o reclutamiento
              exclusivamente en los clientes o Consultores Independientes de otra empresa. No
              utilizaré materiales de ventas considerados como propiedad exclusiva de otras
              compañías.
            </span>
            <p className={styles.paragraphTitle}>
              Declaración de Políticas y Procedimientos para el Consultor Independiente &nbsp;
            </p>
            <ol>
              <li className={styles.list}>Ser un Consultor Independiente.</li>
              <p className={styles.span}>
                Un solicitante se convierte en Consultor Independiente de TERRAMAR cuando completa
                la solicitud en línea y esta es aceptada por TERRAMAR. Una vez aceptada la
                solicitud, el Consultor Independiente tiene derecho a comprar productos TERRAMAR a
                precio de Consultor, desarrollar su línea descendente y calificar conforme al plan
                de compensación para recibir comisiones. TERRAMAR se reserva el derecho de rechazar
                cualquier solicitud de Consultor Independiente o solicitud de renovación,
                incluyendo, entre otros, el caso de cualquier persona que haya tenido un interés
                financiero de cualquier tipo en una Consultoría Independiente de TERRAMAR bajo un
                patrocinador diferente durante los seis meses anteriores.
              </p>

              <li className={styles.list}>Edad legal.</li>
              <p className={styles.span}>
                Los Consultores Independientes deberán tener la mayoría de edad legal conforme al
                estado o provincia de su residencia.
              </p>

              <li className={styles.list}>Derechos del Consultor Independiente.</li>
              <p className={styles.span}>
                Todos los Consultores Independientes están autorizados a vender productos y
                servicios de TERRAMAR, así como a participar en el plan de compensación de TERRAMAR.
                Todos los Consultores Independientes podrán inscribir a nuevos Consultores
                Independientes.
              </p>

              <li className={styles.list}>No se requiere compra.</li>
              <p className={styles.span}>
                Ninguna persona está obligada a comprar productos o servicios de TERRAMAR.
              </p>

              <li className={styles.list}>Parejas casadas.</li>
              <p className={styles.span}>
                Las parejas casadas que deseen participar deberán compartir una sola Consultoría
                Independiente. Los Consultores Independientes que contraigan matrimonio deberán
                mantener su condición de Consultores Independientes separados, salvo que uno sea el
                patrocinador directo del otro o tengan el mismo patrocinador; en tales casos, sus
                Consultorías Independientes podrán consolidarse. Cuando una pareja que comparte una
                Consultoría Independiente se divorcia o separa, TERRAMAR continuará pagando
                comisiones y bonos como antes del divorcio o separación hasta que reciba una
                notificación por escrito firmada por ambas partes, o una orden judicial que
                especifique cómo deberán pagarse las futuras comisiones y bonos.
              </p>

              <li className={styles.list}>Intereses simultáneos.</li>
              <p className={styles.span}>
                Los Consultores Independientes, sus cónyuges o dependientes no podrán tener un
                interés financiero en más de una Consultoría Independiente sin el consentimiento
                previo por escrito de TERRAMAR. Por ejemplo, ni un accionista de una corporación que
                sea Consultor Independiente de TERRAMAR ni un socio de una sociedad que sea
                Consultor Independiente de TERRAMAR podrán convertirse en Consultores Independientes
                de TERRAMAR a título individual.
              </p>

              <li className={styles.list}>
                Requisitos para corporaciones, sociedades y fideicomisos.
              </li>
              <p className={styles.span}>
                Las corporaciones, sociedades y fideicomisos podrán solicitar convertirse en
                Consultores Independientes de TERRAMAR únicamente cuando la Solicitud y Acuerdo de
                Consultor Independiente se acompañe de copias de los siguientes documentos:
              </p>

              <ol type='A'>
                <p className={styles.span}>
                  Artículos de incorporación, contrato de sociedad o documentos del fideicomiso,
                  según hayan sido presentados ante el Estado.
                </p>

                <p className={styles.span}>
                  Las corporaciones solicitantes deberán divulgar una lista completa de todos los
                  directores, funcionarios y accionistas de la corporación. Las sociedades deberán
                  divulgar todos los socios generales y limitados. Los fideicomisos deberán divulgar
                  al fideicomisario y al beneficiario.
                </p>

                <p className={styles.span}>
                  Se deberá proporcionar comprobante del Número de Identificación Federal y una
                  copia del Certificado Anual emitido por el Secretario de Estado correspondiente al
                  registro del fideicomiso, sociedad o corporación.
                </p>

                <p className={styles.span}>
                  Los accionistas, socios, beneficiarios, fideicomisarios, directores y
                  funcionarios, según corresponda, aceptan permanecer personalmente responsables
                  ante TERRAMAR y sujetos a sus normas y regulaciones.
                </p>
              </ol>

              <li className={styles.list}>Prohibición de nombres ficticios o asumidos.</li>
              <p className={styles.span}>
                Ninguna persona o entidad podrá solicitar convertirse en Consultor Independiente
                utilizando un nombre ficticio o asumido.
              </p>

              <li className={styles.list}>Condición de contratista independiente.</li>
              <p className={styles.span}>
                Todos los Consultores Independientes son contratistas independientes de TERRAMAR, y
                no franquiciatarios, socios, empleados, agentes ni partícipes en empresas conjuntas
                de TERRAMAR. Los Consultores Independientes tienen estrictamente prohibido declarar
                o insinuar, de manera verbal o escrita, que son franquiciatarios, socios, empleados
                o agentes de TERRAMAR. Los Consultores Independientes no podrán obligar a TERRAMAR a
                contraer compromiso u obligación alguna.
              </p>

              <li className={styles.list}>Renovación anual.</li>
              <p className={styles.span}>
                Los Consultores Independientes deberán renovar anualmente su Consultoría
                Independiente en el aniversario de su inscripción en TERRAMAR. Aunque la
                responsabilidad de renovar recae en cada Consultor Independiente, TERRAMAR enviará
                un recordatorio cuando corresponda su renovación. Cualquier Consultor Independiente
                que decida no renovar se considerará que ha terminado voluntariamente su Consultoría
                Independiente, renunciando así a su posición, derechos de patrocinio y cualquier
                compensación futura.
              </p>

              <li className={styles.list}>Indemnización.</li>
              <p className={styles.span}>
                Los Consultores Independientes aceptan indemnizar y mantener indemne a TERRAMAR, sus
                accionistas, empleados, agentes y sucesores frente a cualquier reclamación, demanda,
                responsabilidad, pérdida, costo o gasto (incluidos los honorarios de abogados) que
                surjan o se alegue que surgen en relación con la Consultoría Independiente y
                cualquier asunto relacionado con el cumplimiento del Acuerdo de Consultor
                Independiente.
              </p>

              <li className={styles.list}>Impuestos.</li>
              <p className={styles.span}>
                Los Consultores Independientes serán considerados contratistas independientes para
                todos los efectos fiscales federales o estatales. En tal carácter, no serán
                considerados empleados, franquiciatarios, socios o agentes de TERRAMAR con respecto
                al Código de Rentas Internas, la Ley del Seguro Social, la Ley Federal de Desempleo,
                las leyes estatales de desempleo o cualquier otra ley o reglamento federal, estatal
                o local aplicable.
              </p>

              <li className={styles.list}>Cumplimiento legal.</li>
              <p className={styles.span}>
                Todos los Consultores Independientes deberán cumplir con todas las leyes y
                regulaciones federales, estatales y locales aplicables al funcionamiento de sus
                negocios. Cada Consultor Independiente es responsable de sus propias decisiones
                administrativas y gastos, incluidos todos los impuestos estimados sobre ingresos y
                trabajo independiente. Al final de cada año calendario, TERRAMAR emitirá un
                Formulario IRS 1099-MISC por compensación a contratistas independientes, según lo
                exija la ley.
              </p>

              <li className={styles.list}>Número de identificación del Consultor Independiente.</li>
              <p className={styles.span}>
                Todos los Consultores Independientes deberán proporcionar un número de Seguro Social
                (Social Security Number) o un Número de Identificación Federal (Federal ID Number),
                el cual TERRAMAR utilizará hasta que se asigne un número de identificación de
                Consultor Independiente y para todos los fines de informes gubernamentales.
                Respetando los derechos de quienes no cuentan con número fiscal, TERRAMAR decide,
                como parte del derecho contractual, celebrar acuerdos únicamente con quienes estén
                dispuestos a proporcionar un número de identificación fiscal. El número de
                identificación del Consultor Independiente deberá indicarse en toda correspondencia
                con TERRAMAR, incluidos formularios de inscripción, pedidos de productos, etc.
              </p>

              <li className={styles.list}>Otros productos y servicios.</li>
              <p className={styles.span}>
                Los Consultores Independientes no están restringidos de vender productos y servicios
                de otras compañías. Sin embargo, queda estrictamente prohibida la promoción de
                productos, servicios u oportunidades de ingresos de otras compañías de venta directa
                dirigida a clientes o Consultores Independientes de TERRAMAR. Cualquier Consultor
                Independiente que infrinja esta norma se expone a la suspensión o terminación de su
                Consultoría Independiente.
              </p>

              <li className={styles.list}>No existen territorios exclusivos.</li>
              <p className={styles.span}>
                No hay territorios exclusivos para fines de comercialización o de inscripción, ni
                ningún Consultor Independiente podrá insinuar o declarar que posee un territorio
                exclusivo. No existen limitaciones geográficas (dentro de los Estados Unidos y sus
                posesiones) para la inscripción de Consultores Independientes.
              </p>

              <li className={styles.list}>La inscripción no genera compensación.</li>
              <p className={styles.span}>
                Los Consultores Independientes de TERRAMAR pueden inscribir a otros Consultores
                Independientes en el programa TERRAMAR. Sin embargo, los Consultores Independientes
                son compensados únicamente con base en el volumen de negocio, y nunca por inscribir
                a nuevos participantes en el programa.
              </p>

              <li className={styles.list}>Solicitudes múltiples.</li>
              <p className={styles.span}>
                Si un solicitante presenta múltiples solicitudes, solo se aceptará el primer
                formulario completo recibido por TERRAMAR. TERRAMAR se reserva el derecho de
                resolver dichas disputas.
              </p>

              <li className={styles.list}>Obligaciones de los patrocinadores.</li>
              <p className={styles.span}>
                Los Consultores Independientes que decidan inscribir a otros deben asegurar la
                capacitación adecuada de los Consultores Independientes inscritos. “Capacitación
                adecuada” incluye (pero no se limita a) la educación sobre las normas y regulaciones
                de TERRAMAR, el plan de compensación, la información sobre productos, las prácticas
                comerciales sólidas, las estrategias de ventas y la conducta ética. Un patrocinador
                debe mantener una relación de liderazgo profesional y continua con los Consultores
                Independientes de su organización, y cumplir con la obligación de actuar como mentor
                o entrenador de ventas legítimo en la venta o entrega de productos al consumidor
                final. Ejemplos de dicha supervisión pueden incluir, entre otros: boletines
                informativos, correspondencia escrita, reuniones personales, contacto telefónico,
                mensajes de voz, correo electrónico, sesiones de capacitación, acompañamiento a
                capacitaciones de TERRAMAR y el intercambio de información genealógica con los
                inscritos. Los Consultores Independientes deberán estar en condiciones de
                proporcionar a TERRAMAR, si esta lo solicita, evidencia del cumplimiento continuo de
                sus responsabilidades como patrocinadores.
              </p>

              <li className={styles.list}>Transferencia de patrocinio.</li>
              <p className={styles.span}>
                Debido a la relación crítica entre un patrocinador (upline) y un consultor
                descendente (downline), TERRAMAR desaconseja firmemente las solicitudes o intentos
                de transferir patrocinio. Sin embargo, en circunstancias extraordinarias, se
                considerará una solicitud de transferencia sin grupo, siempre que se presenten las
                firmas notarizadas de consentimiento de los cinco patrocinadores inmediatos. Una
                solicitud de transferencia con grupo será considerada si se presentan las firmas
                notarizadas de consentimiento de los cinco patrocinadores inmediatos y las firmas
                notarizadas de cada consultor descendente que desee ser incluido en la
                transferencia. Todas las transferencias de patrocinio requieren la aprobación final
                de TERRAMAR, cuya decisión tomará en cuenta el beneficio general de la Compañía. Se
                podrá cobrar una tarifa administrativa por modificar los registros corporativos.
              </p>

              <li className={styles.list}>Terminación voluntaria.</li>
              <p className={styles.span}>
                Un Consultor Independiente puede dar por terminada su Consultoría Independiente
                voluntariamente al no renovar cuando corresponda, o mediante notificación escrita a
                TERRAMAR. La terminación voluntaria surtirá efecto en la fecha en que TERRAMAR
                reciba dicha notificación en su oficina principal. Un Consultor Independiente que
                haya terminado su Consultoría podrá volver a solicitar su inscripción después de un
                período de seis meses desde la fecha de terminación.
              </p>

              <li className={styles.list}>Terminación involuntaria.</li>
              <p className={styles.span}>
                Un Consultor Independiente podrá ser terminado por violar cualquiera de los términos
                de este Acuerdo. TERRAMAR entregará una notificación por escrito de la terminación
                de la Consultoría Independiente del Consultor que haya cometido la infracción,
                citando las pruebas de la misma. Si el Consultor Independiente no responde dentro de
                los 15 días siguientes, la terminación se considerará efectiva tras la decisión
                final de TERRAMAR. La notificación de dicha decisión se enviará por correo
                certificado a la dirección registrada del Consultor Independiente infractor. En los
                casos en que la ley estatal aplicable sea inconsistente con lo anterior, el
                procedimiento se modificará automáticamente para cumplir con la normativa
                correspondiente. Un Consultor Independiente terminado de forma involuntaria no podrá
                volver a presentar una solicitud a TERRAMAR por un período de un año a partir de la
                fecha efectiva de terminación.
              </p>

              <li className={styles.list}>Apelaciones.</li>
              <p className={styles.span}>
                Un Consultor Independiente terminado involuntariamente puede apelar la terminación
                mediante el envío de una carta de apelación, indicando los fundamentos de la misma.
                Esta carta debe enviarse por correo postal de los Estados Unidos o servicio privado
                de entrega con acuse de recibo, y debe ser recibida por TERRAMAR dentro de los 15
                días posteriores a la fecha de envío de la notificación de terminación de la
                Compañía. Si TERRAMAR no recibe la carta de apelación dentro del plazo establecido,
                la terminación involuntaria se considerará final automáticamente. Si un Consultor
                Independiente presenta una apelación dentro del plazo, TERRAMAR, a su entera
                discreción, revisará y reconsiderará la terminación y notificará al Consultor
                Independiente su decisión. La decisión de la Compañía será definitiva y no estará
                sujeta a revisión adicional. Si la apelación es denegada, la terminación permanecerá
                en vigor desde la fecha de la notificación original de la Compañía.
              </p>

              <li className={styles.list}>Efecto de la suspensión.</li>
              <p className={styles.span}>
                Si TERRAMAR considera necesario suspender a un Consultor Independiente, dicha
                suspensión puede implicar que el Consultor no tendrá derecho a representarse como
                Consultor Independiente de TERRAMAR, y que cualquier comisión, regalía o bono
                pendiente será retenido por TERRAMAR hasta la resolución del caso. A discreción de
                la Compañía, los productos y servicios podrán ser adquiridos por un Consultor
                suspendido a precio de mayoreo. Sin embargo, si la suspensión concluye en
                terminación, los productos y servicios solo podrán adquirirse a través de otro
                Consultor Independiente de TERRAMAR.
              </p>

              <li className={styles.list}>Efecto de la terminación.</li>
              <p className={styles.span}>
                En caso de terminación de un Consultor Independiente, a partir de la fecha efectiva
                de dicha terminación, el Consultor no podrá seguir vendiendo productos o servicios
                de TERRAMAR ni inscribir a otros Consultores Independientes. El Consultor
                Independiente también perderá todos los derechos a comisiones, bonos y demás
                beneficios.
              </p>

              <li className={styles.list}>Límites sobre transferencias o venta. </li>
              <p className={styles.span}>
                Un Consultor Independiente puede vender, ceder o transferir su Consultoría
                Independiente a una persona que no sea Consultor Independiente de TERRAMAR, pero
                primero deberá otorgar a su patrocinador inmediato el derecho de preferencia.
                Ninguna venta, cesión o transferencia será efectiva sin la aprobación previa por
                escrito de TERRAMAR, cuya aprobación no será negada de manera irrazonable. Si la
                Compañía determina, a su sola discreción, que la transferencia fue realizada para
                evadir el cumplimiento de este Acuerdo, la transferencia será declarada nula y sin
                efecto, y la Consultoría revertirá al Consultor transferente, quien será tratado
                como si la transferencia nunca hubiera ocurrido. Se podrá cobrar una tarifa
                administrativa por modificar los registros corporativos.
              </p>

              <li className={styles.list}>Relaciones con proveedores.</li>
              <p className={styles.span}>
                Ningún Consultor Independiente podrá contactar, directa o indirectamente, hablar o
                comunicarse con ningún representante de un proveedor o fabricante de TERRAMAR, salvo
                que TERRAMAR lo disponga. La violación de esta regla puede resultar en la
                terminación de los beneficios del Consultor Independiente y posibles reclamaciones
                por daños si la relación con el proveedor se ve comprometida por dicho contacto.
              </p>

              <li className={styles.list}>Acuerdo de confidencialidad.</li>
              <p className={styles.span}>
                La información contenida en cualquier informe genealógico o de línea descendente
                proporcionado a un Consultor Independiente por TERRAMAR es propiedad exclusiva y
                confidencial de TERRAMAR, y se transmite al Consultor Independiente bajo estricta
                confidencialidad. El Consultor Independiente acepta no divulgar dicha información a
                terceros, directa o indirectamente, ni utilizarla para competir con TERRAMAR o para
                cualquier otro propósito distinto a promover la oportunidad de ingresos de TERRAMAR.
                El Consultor Independiente y TERRAMAR acuerdan que, de no existir este acuerdo de
                confidencialidad y no divulgación, TERRAMAR no proporcionaría dicha información al
                Consultor. Cualquier Consultor que infrinja esta norma se expone a suspensión o
                terminación. TERRAMAR se reserva el derecho de reclamar daños en la máxima medida
                permitida por la ley.
              </p>

              <li className={styles.list}>Sucesión.</li>
              <p className={styles.span}>
                Tras el fallecimiento de un Consultor Independiente, la Consultoría Independiente se
                transferirá conforme al testamento o las leyes de sucesión intestada aplicables.
                TERRAMAR requerirá que el sucesor firme y acepte el Acuerdo de Consultor
                Independiente vigente. El sucesor tendrá los mismos derechos y obligaciones que
                cualquier otro Consultor Independiente de TERRAMAR.
              </p>

              <li className={styles.list}>Marcas registradas.</li>
              <p className={styles.span}>
                El nombre TERRAMAR y los nombres de todos los productos y servicios TERRAMAR son
                marcas registradas o no registradas propiedad de TERRAMAR. Solo TERRAMAR está
                autorizado para producir y comercializar productos y material impreso bajo dichas
                marcas. El uso del nombre TERRAMAR en cualquier artículo no producido o autorizado
                por TERRAMAR está prohibido.
              </p>

              <li className={styles.list}>Cheques impresos.</li>
              <p className={styles.span}>
                Los Consultores Independientes de TERRAMAR no tienen permitido utilizar el nombre
                comercial TERRAMAR ni ninguna de sus marcas registradas en sus cuentas bancarias
                personales o comerciales. Sin embargo, los Consultores Independientes pueden
                imprimir en sus cheques comerciales la leyenda “Consultor Independiente de productos
                TERRAMAR”.
              </p>

              <li className={styles.list}>Listado en páginas amarillas o blancas.</li>
              <p className={styles.span}>
                Los Consultores Independientes no tienen permitido utilizar el nombre comercial
                TERRAMAR al anunciar sus números telefónicos o de fax en las secciones de páginas
                blancas o amarillas de los directorios telefónicos.
              </p>

              <li className={styles.list}>Tarjetas de presentación o membretes impresos.</li>
              <p className={styles.span}>
                Los Consultores Independientes de TERRAMAR no tienen permitido incorporar en sus
                tarjetas de presentación o membretes gráficos ningún nombre comercial ni marca
                registrada de TERRAMAR. Solo se permite el uso de las versiones gráficas y redacción
                aprobadas por TERRAMAR, y el membrete debe ser solicitado directamente a TERRAMAR o
                a una fuente aprobada por la Compañía.
              </p>

              <li className={styles.list}>Material corporativo.</li>
              <p className={styles.span}>
                Solo la literatura oficial de TERRAMAR podrá utilizarse para presentar los
                productos, servicios y la oportunidad de ingresos de TERRAMAR. El material
                corporativo no podrá duplicarse ni reimprimirse sin autorización previa y por
                escrito de TERRAMAR. Todo material promocional de cualquier tipo, incluido el
                electrónico, deberá ser aprobado por adelantado y por escrito por TERRAMAR.
              </p>

              <li className={styles.list}>Entrevistas con medios de comunicación.</li>
              <p className={styles.span}>
                Los Consultores Independientes tienen prohibido conceder entrevistas a radio,
                televisión, periódicos o revistas, así como utilizar apariciones públicas,
                conferencias o cualquier tipo de declaración ante medios para publicitar a TERRAMAR,
                sus productos, servicios o su negocio personal de TERRAMAR, salvo con la aprobación
                expresa y por escrito de TERRAMAR. Todos los contactos y consultas de medios deben
                coordinarse a través de un Representante Corporativo autorizado de TERRAMAR.
              </p>

              <li className={styles.list}>Política de Internet y sitios web.</li>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Ningún Consultor Independiente podrá diseñar de manera independiente un sitio
                    web que utilice los nombres, logotipos o descripciones de productos de TERRAMAR
                    sin autorización escrita de TERRAMAR.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Ningún Consultor Independiente podrá publicar anuncios “ciegos” en Internet que
                    hagan representaciones de productos u oportunidades de ingresos que estén o
                    puedan estar asociadas con TERRAMAR.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Ningún Consultor Independiente podrá, bajo ninguna circunstancia, utilizar
                    Internet con el propósito de realizar envíos masivos o correos electrónicos no
                    solicitados, comúnmente conocidos como “spam”.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Ningún Consultor Independiente podrá violar leyes locales, estatales o federales
                    relacionadas con el uso de Internet ni infringir los códigos éticos generalmente
                    aceptados de conducta en la red.
                  </span>
                </li>
              </ol>

              <li className={styles.list}>Comunicaciones independientes.</li>
              <p className={styles.span}>
                Los Consultores Independientes, como contratistas independientes, son alentados a
                distribuir información y orientación a sus respectivas líneas descendentes. TERRAMAR
                fomenta el uso de boletines informativos, talleres de capacitación y otros programas
                organizacionales. Los Consultores Independientes deberán identificar sus
                comunicaciones personales como tales, y no deberán dar la impresión de que son
                comunicaciones oficiales de TERRAMAR.
              </p>

              <li className={styles.list}>Capacitación del Consultor Independiente.</li>
              <p className={styles.span}>
                Los Consultores Independientes son responsables de proporcionar capacitación a los
                Consultores Independientes que inscriban. La asistencia de capacitación se
                proporciona en su Oficina Virtual (“Backoffice”) y en materiales audiovisuales.
                Además, cada Consultor Independiente recibe publicaciones periódicas de TERRAMAR que
                incluyen capacitación continua e información sobre productos y servicios. Asimismo,
                los Consultores Independientes pueden asistir a talleres locales y regionales de
                capacitación y participar en conferencias nacionales de capacitación organizadas por
                TERRAMAR.
              </p>

              <li className={styles.list}>Avales.</li>
              <p className={styles.span}>
                No se podrá alegar ningún tipo de aval o respaldo, incluidos los de funcionarios de
                TERRAMAR, excepto aquellos expresamente comunicados en la literatura oficial de
                TERRAMAR o aprobados por escrito.
              </p>

              <li className={styles.list}>Prohibición de copias.</li>
              <p className={styles.span}>
                Los Consultores Independientes no podrán copiar, para su venta o uso personal,
                material de audio o video que describa la oportunidad de ingresos, presentaciones de
                productos o servicios, eventos o discursos de TERRAMAR, incluidas las conferencias
                telefónicas, sin la autorización escrita de TERRAMAR. TERRAMAR podrá solicitar
                medidas judiciales o reclamar daños por el uso no autorizado de sus derechos de
                autor, marcas registradas o materiales. La grabación en video o audio de reuniones y
                conferencias de TERRAMAR está estrictamente prohibida. La fotografía fija estará
                permitida únicamente a discreción del anfitrión del evento.
              </p>

              <li className={styles.list}>Respuesta telefónica.</li>
              <p className={styles.span}>
                Los Consultores Independientes no podrán contestar el teléfono diciendo “TERRAMAR” o
                de cualquier otra manera que pueda llevar al interlocutor a creer que ha contactado
                las oficinas corporativas de TERRAMAR.
              </p>

              <li className={styles.list}>Prohibición de reempaque.</li>
              <p className={styles.span}>
                Los Consultores Independientes no podrán reempacar de ninguna manera los productos,
                servicios o materiales de TERRAMAR.
              </p>

              <li className={styles.list}>Solicitud y Acuerdo de Consultor Independiente.</li>
              <p className={styles.span}>
                No se podrán pagar comisiones ni bonificaciones hasta que TERRAMAR haya recibido y
                aceptado una Solicitud y Acuerdo de Consultor Independiente completa. Las comisiones
                se pagan únicamente sobre la venta de productos y servicios TERRAMAR. No se pagan
                comisiones por la compra del kit de inicio del Consultor Independiente, el cual se
                vende al costo de la Compañía.
              </p>

              <li className={styles.list}>Periodo de calendario.</li>
              <p className={styles.span}>
                Las comisiones, bonificaciones, premios y reconocimientos se calculan mensualmente,
                con base en el calendario mensual.
              </p>

              <li className={styles.list}>Fecha de pago de comisiones y bonificaciones.</li>
              <p className={styles.span}>
                Las comisiones se pagan mensualmente, aproximadamente dentro de los primeros diez
                (10) días del mes siguiente a aquel en que se generaron.
              </p>

              <li className={styles.list}>Pagos de comisiones.</li>
              <p className={styles.span}>
                Consulte el plan de compensación descrito en el Manual del Consultor.
              </p>

              <li className={styles.list}>Acumulación de inventario prohibida.</li>
              <p className={styles.span}>
                El programa TERRAMAR depende de las ventas al por menor al consumidor final; por lo
                tanto, se desalientan todas las formas de acumulación de inventario o carga de
                producto. TERRAMAR reconoce que los Consultores Independientes pueden desear comprar
                ciertos productos en cantidades razonables para su propio uso y para tener
                disponibilidad para nuevos Consultores Independientes al momento de su inscripción.
                Sin embargo, TERRAMAR prohíbe estrictamente la compra de productos en cantidades
                irrazonables con el único propósito de calificar para un ascenso dentro del plan de
                compensación.
              </p>

              <li className={styles.list}>
                Calificación de volumen de ventas mediante toma de pedidos.
              </li>
              <p className={styles.span}>
                La Compañía ha establecido requisitos mínimos de volumen personal y grupal de
                negocio. Dichos requisitos mínimos de volumen también pueden cumplirse mediante la
                toma de pedidos de clientes minoristas, los cuales serán procesados y enviados
                directamente al cliente por la Compañía.
              </p>

              <li className={styles.list}>Costos de envío.</li>
              <p className={styles.span}>
                Los Consultores Independientes tienen la responsabilidad de indicar la dirección de
                destino. Los métodos disponibles se especifican en cada formulario de pedido y los
                costos prepagados, si se seleccionan, pueden calcularse según la información de
                envío y manejo proporcionada. NOTA: Si el destinatario de un pedido enviado por
                TERRAMAR rechaza la entrega y el envío es devuelto a TERRAMAR, el estado del
                Consultor Independiente que realizó el pedido pasará a “inactivo” hasta resolver la
                situación. Los cargos por entrega no aceptada serán debitados a la cuenta del
                Consultor Independiente.
              </p>

              <li className={styles.list}>Mercancía dañada.</li>
              <p className={styles.span}>
                La empresa de transporte es responsable de cualquier daño que ocurra después de
                haber tomado posesión física de los bienes. Un Consultor Independiente que reciba
                mercancía dañada deberá seguir este procedimiento:
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>Aceptar la entrega.</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Antes de que el conductor se retire, anotar en el comprobante de entrega el
                    número de cajas aparentemente dañadas.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Conservar los productos o cajas dañadas para su inspección por parte del agente
                    de transporte.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Agendar una cita con la empresa de transporte para que inspeccione los bienes
                    dañados.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Presentar una reclamación ante la empresa de transporte.
                  </span>
                </li>
              </ol>

              <li className={styles.list}>Recibos y precios minoristas sugeridos.</li>
              <p className={styles.span}>
                Los Consultores Independientes deben proporcionar a todos los compradores minoristas
                de productos TERRAMAR un recibo escrito. Este formato de recibo está disponible en
                la Oficina Virtual (Backoffice). Aunque TERRAMAR proporciona un precio minorista
                sugerido como referencia, los Consultores Independientes pueden vender los productos
                TERRAMAR al precio minorista que elijan.
              </p>

              <li className={styles.list}>Precio Mínimo Anunciado (MAP).</li>
              <p className={styles.span}>
                TERRAMAR establece que el Precio al Público General (también denominado “Precio
                Minorista”) publicado a través de sus canales oficiales se considerará el Precio
                Mínimo Anunciado (MAP) para todos sus productos. Se considerarán canales oficiales
                de publicación de precios los siguientes:
              </p>

              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>El Catálogo de Ofertas</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>La Revista Mensual</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    El sitio web oficial:
                    <a href='www.terramarbrandsusa.com'>www.terramarbrandsusa.com</a>
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Las cuentas oficiales de redes sociales de Terramar USA
                  </span>
                </li>
              </ol>

              <p className={styles.span}>
                Este precio deberá respetarse en cualquier canal público autorizado de venta,
                promoción o comunicación, incluyendo, entre otros, cuentas personales de redes
                sociales (Facebook, Instagram, TikTok, etc.), sitios web personales, catálogos
                impresos independientes o cualquier otro medio de venta directa o indirecta
                accesible al público en general. Está estrictamente prohibido anunciar o publicar
                precios por debajo del MAP, o utilizar lenguaje que sugiera descuentos no
                autorizados, tales como: “precio especial”, “pregunta por el precio”, “oferta
                exclusiva”, “precio por mensaje”, “DM para más información”, etc.
              </p>

              <li className={styles.list}>Impuesto sobre ventas.</li>
              <p className={styles.span}>
                En las compras realizadas a la Compañía, TERRAMAR recauda y remite el impuesto
                estatal aplicable que pueda corresponder sobre el precio sugerido de venta de
                aquellos productos y/o materiales sujetos a dicho impuesto. La tasa aplicable se
                basa en la dirección a la que se envía el producto o material. Los Consultores
                Independientes que soliciten una compra exenta de impuestos para reventa (no
                permitido en todos los estados) deberán proporcionar a la Compañía una copia de su
                certificado de exención de reventa vigente, mostrando su número de registro. Este
                número deberá aparecer en todos los pedidos realizados a TERRAMAR. Posteriormente,
                el Consultor Independiente deberá cobrar el impuesto correspondiente a su cliente
                minorista y remitirlo a la autoridad fiscal estatal y local correspondiente. Todos
                los Consultores Independientes deberán pagar impuestos a la Compañía por sus compras
                personales destinadas a uso o consumo propio. Como Consultor Independiente, usted
                acepta cumplir con las normas y procedimientos establecidos en los acuerdos de
                recaudación de impuestos sobre ventas que la Compañía pueda suscribir con los
                distintos estados y jurisdicciones locales.
              </p>

              <li className={styles.list}>Establecimientos minoristas.</li>
              <p className={styles.span}>
                Los productos TERRAMAR no pueden venderse a, ni exhibirse en, establecimientos
                minoristas, incluidos, entre otros, mercados ambulantes, ferias, puestos en centros
                comerciales o restaurantes, así como en marketplaces como Amazon, eBay, Walmart o
                cualquier otra tienda en línea. Cualquier excepción requiere aprobación previa y por
                escrito.
              </p>

              <li className={styles.list}>Establecimientos orientados a servicios.</li>
              <p className={styles.span}>
                Está permitido tomar pedidos de productos y servicios TERRAMAR en negocios como
                oficinas de servicios profesionales, establecimientos de atención “con cita previa”
                o similares que no sean minoristas.
              </p>

              <li className={styles.list}>Cambios de precios.</li>
              <p className={styles.span}>
                Todos los precios de productos y material impreso de TERRAMAR están sujetos a
                cambios sin previo aviso.
              </p>

              <li className={styles.list}>Devoluciones de clientes minoristas. </li>
              <p className={styles.span}>
                TERRAMAR ofrece una garantía incondicional del 100 % de reembolso en los productos
                vendidos a clientes minoristas. Cada Consultor Independiente TERRAMAR debe honrar
                esta garantía. Si un cliente minorista no está satisfecho con un producto TERRAMAR
                por cualquier motivo, podrá devolverlo al Consultor Independiente que se lo vendió
                dentro de los 30 días siguientes para un reemplazo o reembolso total del precio de
                compra. TERRAMAR reemplazará el producto devuelto siempre que se cumplan los
                siguientes pasos y condiciones:
              </p>

              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    El producto sea devuelto a TERRAMAR por el Consultor Independiente que realizó
                    la venta.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    El producto sea recibido por TERRAMAR dentro de los diez (10) días posteriores a
                    la fecha de devolución al Consultor Independiente.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    La devolución esté acompañada de una declaración completa y firmada que incluya:
                  </span>
                </li>
                <ol>
                  <li className={styles.list}>
                    <span className={styles.span}>
                      Una declaración firmada del cliente minorista explicando el motivo de la
                      devolución.
                    </span>
                  </li>

                  <li className={styles.list}>
                    <span className={styles.span}>
                      Una copia del recibo original de venta al por menor.
                    </span>
                  </li>

                  <li className={styles.list}>
                    <span className={styles.span}>
                      La porción no utilizada del producto en su envase original.
                    </span>
                  </li>
                </ol>

                <li className={styles.list}>
                  <span className={styles.span}>
                    El nombre, dirección y número telefónico del cliente minorista.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    El uso de cajas y materiales de empaque adecuados, y el método de envío más
                    económico.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>TERRAMAR cubrirá el costo de envío del reemplazo.</p>

              <p className={styles.span}>
                TERRAMAR no reembolsará al Consultor Independiente el precio de compra de
                devoluciones de clientes minoristas ni reemplazará productos si no se cumplen las
                condiciones de esta política.
              </p>

              <li className={styles.list}>Control de calidad.</li>
              <p className={styles.span}>
                TERRAMAR reemplazará, dentro de los 30 días posteriores a la compra, cualquier
                producto que se determine defectuoso. No obstante, ningún producto deberá devolverse
                a TERRAMAR sin previa autorización. Comuníquese con TERRAMAR al 01 800 313 0903 o
                por correo electrónico a
                <span>
                  <a href='mailto:customerservices@tmbrandsusa.com' className={styles.link}>
                    &nbsp;customerservices@tmbrandsusa.com&nbsp;
                  </a>
                </span>
                y cumpla estrictamente con los siguientes requisitos:
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Se deberá presentar una solicitud de reemplazo por escrito, indicando el motivo
                    y acompañada del comprobante de pago y copia del pedido o guía de envío.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    TERRAMAR indicará al Consultor Independiente dónde enviar el producto para su
                    verificación y proporcionará las etiquetas de devolución correspondientes. Tras
                    la recepción y verificación del producto, TERRAMAR enviará el reemplazo según
                    corresponda.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>
                NOTA: Cualquier devolución recibida sin autorización previa causará que el Consultor
                Independiente quede con estatus “inactivo”. Además, no se garantiza que el producto
                sea elegible para reemplazo.
              </p>

              <li className={styles.list}>Devoluciones por terminación.</li>
              <p className={styles.span}>
                En caso de terminación, si el Consultor Independiente ha comprado productos para
                inventario o materiales de apoyo durante la vigencia de su contrato, todos los
                productos sin uso y en condiciones de reventa, adquiridos dentro de los 12 meses
                previos a la cancelación, podrán ofrecerse a TERRAMAR para recompra. La recompra se
                realizará a un precio no inferior al 90 % del costo neto original pagado por el
                Consultor. Además, la Compañía cumplirá con los requisitos legales de recompra
                aplicables en cada jurisdicción. TERRAMAR también recomprará materiales de venta y
                el kit de inicio TERRAMAR dentro de un año desde la fecha de compra, siempre que los
                materiales estén vigentes y en condiciones de reventa.
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    La solicitud de devolución deberá presentarse por escrito y acompañarse del
                    comprobante de pago y copia del pedido.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    TERRAMAR indicará al Consultor Independiente dónde enviar el producto para
                    inventario y verificación, y proporcionará las etiquetas de devolución
                    correspondientes. Una vez recibido e inspeccionado el producto, TERRAMAR
                    procesará el reembolso correspondiente.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    El Consultor Independiente deberá pagar los gastos de envío de la devolución.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>
                NOTA: Los productos o materiales que no estén en condiciones de reventa serán
                devueltos al Consultor Independiente a su propio costo.
              </p>

              <li className={styles.list}>Derecho de cancelación del comprador.</li>
              <p className={styles.span}>
                La ley federal otorga al comprador el derecho de cancelar ciertas ventas sin
                penalización antes de la medianoche del tercer día hábil posterior a la transacción.
                Esta norma aplica a ventas minoristas de $25 o más realizadas fuera del
                establecimiento principal del vendedor. El formulario de pedido TERRAMAR incluye
                todos los avisos legales requeridos. Debe ser firmado por el comprador, y se deben
                entregar dos copias al comprador en cada venta. Además, el Consultor Independiente
                debe informar verbalmente al comprador sobre el derecho de cancelación de tres días
                al momento de la firma del contrato o compra de los bienes. En relación con los
                productos, cuando la política de Devoluciones de Clientes Minoristas (descrita
                anteriormente) sea más favorable al cliente, dicha política prevalecerá. Respecto a
                los servicios, al término del período de tres días, todas las ventas de servicios se
                considerarán finales y no reembolsables.
              </p>

              <li className={styles.list}>Responsabilidad del Consultor Independiente.</li>
              <p className={styles.span}>
                Si un cliente minorista envía o entrega a un Consultor Independiente una
                notificación válida de cancelación antes de la medianoche del tercer día hábil
                posterior al pedido o compra del programa, servicio o producto, el Consultor deberá
                honrarla. Si el comprador ya ha recibido los bienes, deberá devolverlos junto con la
                notificación en condiciones sustancialmente iguales a las que fueron entregadas. En
                el caso de servicios, los materiales sellados que describen los servicios deberán
                devolverse sin abrir. Dentro de los diez días hábiles posteriores a la recepción de
                la notificación, el Consultor Independiente deberá reembolsar todos los pagos
                efectuados conforme al contrato de venta.
              </p>

              <li className={styles.list}>Responsabilidad.</li>
              <p className={styles.span}>
                En la medida permitida por la ley, TERRAMAR no será responsable, y el Consultor
                Independiente libera a TERRAMAR de toda responsabilidad y renuncia a cualquier
                reclamación por pérdida de ganancias, daños indirectos, directos, especiales o
                consecuenciales, o cualquier otra pérdida incurrida o sufrida por el Consultor
                Independiente como resultado de: a. el incumplimiento del Consultor Independiente de
                este Acuerdo, b. la operación del negocio del Consultor Independiente, c. cualquier
                dato o información incorrecta o errónea proporcionada por el Consultor
                Independiente, o d. la falta de proporcionar información o datos necesarios para que
                TERRAMAR opere su negocio, incluyendo, sin limitación, el proceso de inscripción y
                aceptación del Consultor Independiente en la oportunidad de ingresos o el pago de
                comisiones y bonos.
              </p>

              <li className={styles.list}>Conservación de registros.</li>
              <p className={styles.span}>
                TERRAMAR recomienda a todos sus Consultores Independientes mantener registros
                completos y precisos de todas sus transacciones comerciales. Una publicación
                recomendada es la Publicación 911 del IRS para vendedores directos, disponible en
                cualquier oficina del IRS o en su sitio web oficial.
              </p>

              <li className={styles.list}>Declaraciones de ingresos.</li>
              <p className={styles.span}>
                No se podrán realizar declaraciones, proyecciones o representaciones de ingresos a
                posibles Consultores Independientes. Cualquier afirmación falsa, engañosa o
                incorrecta sobre la oportunidad o los productos/servicios está prohibida. En
                ocasiones, los Consultores Independientes presentan cifras hipotéticas de ingresos
                basadas en el potencial del mercadeo en red como si fueran proyecciones reales. Esta
                práctica es contraproducente y está prohibida, ya que puede generar desilusión si
                los resultados reales no coinciden con las expectativas del modelo hipotético.
                <ol type='a'>
                  <li>Declaraciones de Ganancias</li>
                  <ol>
                    <li>
                      Se prohíbe a los Consultores hacer declaraciones de ingresos, proyecciones o
                      testimonios de estilo de vida (por ejemplo: viajes, compra de automóviles,
                      renuncia a empleos, etc.) que puedan ser engañosos o carezcan de sustento.
                    </li>
                    <li>Solo podrán utilizarse materiales oficiales aprobados por TERRAMAR.</li>
                    <li>
                      Todas las comunicaciones deberán aclarar que los ingresos dependen del
                      esfuerzo individual, el tiempo invertido, las habilidades y otros factores
                      variables.
                    </li>
                  </ol>
                  <li>Declaraciones sobre Productos</li>
                  <ol>
                    <li>
                      Los Consultores no pueden hacer afirmaciones médicas, terapéuticas o curativas
                      sobre los productos TERRAMAR.
                    </li>{' '}
                    <li>
                      Solo podrán comunicarse los beneficios aprobados en la literatura oficial de
                      TERRAMAR.
                    </li>
                    <li>
                      Las experiencias personales no deben utilizarse como sustituto de evidencia
                      científica ni como garantía de resultados.
                    </li>
                  </ol>
                </ol>
              </p>

              <li className={styles.list}>Supervisión y monitoreo</li>
              <p className={styles.span}>
                <ol type='a'>
                  <li>
                    TERRAMAR se reserva el derecho de monitorear redes sociales y otras formas de
                    comunicación.
                  </li>
                  <li>
                    Cualquier material que contenga afirmaciones no aprobadas podrá ser solicitado
                    para su eliminación inmediata.
                  </li>
                </ol>
              </p>

              <li className={styles.list}>Cumplimiento y sanciones.</li>

              <p className={styles.span}>
                El incumplimiento de esta o cualquier política relacionada —incluyendo, entre otras,
                la Política de Precio Mínimo Anunciado (MAP) y la Política de Declaraciones de
                Ganancias y Productos— dará lugar a las siguientes acciones disciplinarias:
                <ol type='a'>
                  <li>Primera infracción: advertencia formal por escrito.</li>
                  <li>
                    Segunda infracción: suspensión temporal de la cuenta y actividades del Consultor
                    Independiente hasta que se restablezca el cumplimiento.
                  </li>
                  <li>
                    Tercera infracción: terminación inmediata del contrato del Consultor
                    Independiente.
                  </li>
                </ol>
              </p>
              <p className={styles.span}>
                TERRAMAR se reserva el derecho de monitorear, investigar y hacer cumplir estas
                políticas por cualquier medio legal o contractual que considere necesario, y de
                escalar las acciones disciplinarias dependiendo de la gravedad o recurrencia de la
                infracción.
              </p>

              <li className={styles.list}>Modificaciones.</li>
              <p className={styles.span}>
                TERRAMAR se reserva el derecho de modificar este Acuerdo, sus precios,
                disponibilidad de productos y plan de compensación según lo considere apropiado. Las
                modificaciones serán comunicadas a todos los Consultores Independientes a través de
                publicaciones oficiales de TERRAMAR y serán efectivas y vinculantes a partir de la
                fecha de emisión.
              </p>

              <li className={styles.list}>Cláusula de no renuncia.</li>
              <p className={styles.span}>
                La falta de TERRAMAR en ejercer cualquier facultad establecida en este Acuerdo o en
                exigir el estricto cumplimiento por parte de un Consultor Independiente de cualquier
                obligación o disposición contenida en el mismo, así como cualquier práctica habitual
                distinta entre las partes, no constituirá una renuncia al derecho de la Compañía de
                exigir el cumplimiento exacto del Acuerdo. Cualquier renuncia por parte de la
                Compañía solo será válida si se realiza por escrito y firmada por un funcionario
                autorizado de la misma. La renuncia por parte de la Compañía ante un incumplimiento
                específico no afectará ni limitará sus derechos respecto de incumplimientos
                posteriores, ni afectará los derechos u obligaciones de otros Consultores
                Independientes. Tampoco cualquier demora u omisión de la Compañía en ejercer sus
                derechos derivada de un incumplimiento afectará o limitará sus derechos respecto de
                dicho incumplimiento o de otros futuros.
              </p>

              <li className={styles.list}>Divisibilidad.</li>
              <p className={styles.span}>
                Si, bajo cualquier ley aplicable o norma vinculante, alguna disposición del Acuerdo
                —incluyendo estas reglas y regulaciones, o cualquier especificación, estándar o
                procedimiento operativo establecido por TERRAMAR— se considera inválida o
                inaplicable, TERRAMAR tendrá el derecho de modificar dicha disposición,
                especificación, estándar o procedimiento en la medida necesaria para que sea válido
                y exigible. El Consultor Independiente quedará obligado por cualquier modificación
                de este tipo, la cual solo será efectiva en la jurisdicción donde sea requerida.
              </p>

              <li className={styles.list}>Arbitraje.</li>
              <ol type='A'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Todas las disputas y reclamaciones relacionadas con TERRAMAR, sus productos, el
                    Acuerdo de Consultor o el Plan de Compensación TERRAMAR, incluyendo, entre
                    otras: (1) los derechos y obligaciones del Consultor y de TERRAMAR, (2)
                    cualquier otra reclamación relacionada con el cumplimiento de cualquiera de las
                    partes bajo el Acuerdo de Consultor o las Reglas y Regulaciones, y/o (3) la
                    compra de productos TERRAMAR por parte del Consultor, serán resueltas total y
                    finalmente mediante arbitraje en Miami, Florida, o en otro lugar que TERRAMAR
                    determine, de conformidad con la Ley Federal de Arbitraje y las Reglas de
                    Arbitraje Comercial de la Asociación Americana de Arbitraje (AAA). Los
                    residentes de Luisiana podrán arbitrar en Nueva Orleans. Habrá un solo árbitro,
                    abogado en ejercicio, con experiencia en derecho comercial, preferiblemente con
                    conocimiento en la industria de venta directa, seleccionado del panel
                    proporcionado por la AAA. Cada parte será responsable de sus propios costos y
                    gastos, incluidos honorarios legales y tasas de presentación. Si el Consultor
                    presenta una reclamación o contrademanda contra TERRAMAR, deberá hacerlo de
                    manera individual y no conjunta con otros Consultores ni como parte de una
                    acción colectiva. La decisión del árbitro será definitiva y vinculante para
                    ambas partes, y podrá convertirse en sentencia ante cualquier tribunal
                    competente. Este acuerdo de arbitraje subsistirá incluso tras la terminación o
                    expiración del Acuerdo de Consultor.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    No obstante lo anterior, el árbitro no tendrá jurisdicción sobre disputas
                    relacionadas con la propiedad, validez o registro de cualquier marca u otro
                    derecho de propiedad intelectual o información confidencial de TERRAMAR sin
                    consentimiento previo y por escrito de la Compañía. TERRAMAR podrá buscar los
                    recursos legales pertinentes en cualquier foro aplicable respecto de estas
                    disputas o respecto de montos adeudados. Además de daños monetarios, TERRAMAR
                    podrá obtener medidas cautelares contra el Consultor por cualquier violación del
                    Acuerdo o uso indebido de sus marcas, derechos de autor o información
                    confidencial.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    Nada en esta cláusula impedirá que TERRAMAR solicite y obtenga de cualquier
                    tribunal competente órdenes de embargo, medidas cautelares temporales o
                    cualquier otro recurso judicial necesario para proteger sus intereses antes,
                    durante o después del arbitraje, o mientras se espera la resolución del mismo.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    La existencia de cualquier reclamación o causa de acción por parte del Consultor
                    contra TERRAMAR, ya sea derivada del Acuerdo o de otra índole, no constituirá
                    una defensa para el cumplimiento de las obligaciones del Consultor establecidas
                    en el Acuerdo o las Reglas.
                  </span>
                </li>
              </ol>

              <li className={styles.list}>Jurisdicción.</li>
              <p className={styles.span}>
                Todas las disputas y reclamaciones relacionadas con TERRAMAR, este Acuerdo, el plan
                de compensación TERRAMAR, sus productos, o los derechos y obligaciones de un
                Consultor Independiente, serán resueltas total y finalmente en Miami, Florida, o en
                otro lugar que TERRAMAR determine. Residentes de Luisiana: en caso de disputa
                jurisdiccional, el Consultor Independiente podrá presentar su reclamación o demanda
                dentro del estado de Luisiana, aplicándose las leyes de dicho estado.
              </p>

              <li className={styles.list}>Limitación de daños.</li>
              <p className={styles.span}>
                En la medida permitida por la ley, TERRAMAR y sus afiliadas, funcionarios,
                directores, empleados y demás representantes no serán responsables —y el Consultor
                Independiente renuncia expresamente— a cualquier reclamación por pérdida de
                ganancias o daños incidentales, especiales, consecuenciales o ejemplares derivados
                de cualquier reclamación relacionada con la actuación, omisión o incumplimiento de
                TERRAMAR respecto a la relación comercial entre las partes, ya sea por contrato,
                agravio o responsabilidad estricta. Asimismo, se acuerda que cualquier daño al
                Consultor Independiente no excederá, y queda expresamente limitado al valor de los
                productos y servicios TERRAMAR no vendidos que el Consultor posea, junto con las
                comisiones pendientes de pago.
              </p>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PolicesAndProceduresING;
